<template>
  <div>
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>

    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6 col-12" v-for="(t, i) in waiverTypes" :key="t.id + i">
        <card class="card-white h-100" body-classes="d-flex flex-column">
          <div class="row justify-content-center">
            <div class="col text-right">
              <badge v-if="t.is_active === 1"  type="success">enabled</badge>
              <badge v-else type="danger">disabled</badge>
            </div>
          </div>
          <div class="row justify-content-center">
            <i v-if="t.type === 'traditional'" class="tim-icons icon-notes" style="font-size: xxx-large"></i>
            <i v-if="t.type === 'shareable'" class="tim-icons icon-link-72" style="font-size: xxx-large"></i>
            <i v-if="t.type === 'lookup'" class="tim-icons el-icon-search" style="font-size: xxx-large"></i>
            <i v-if="t.type === 'generic'" class="tim-icons icon-paper" style="font-size: xxx-large"></i>
          </div>
          <div class="row mt-3 justify-content-center">
            <div class="col text-center" v-if="t.type === 'traditional'">
              <h4 class="text-default text-uppercase" >Traditional waiver</h4>
              <small>A standard waiver form best suited for general check-in workflows. Works seamlessly with kiosks or when accessed via a shared QR code.</small>
            </div>
            <div class="col text-center" v-if="t.type === 'shareable'">
              <h4 class="text-default text-uppercase">Shareable waiver</h4>
              <small>A unique, booking-specific waiver link that can be sent to the customer after purchase. Designed for easy distribution to participants in a group.</small>
            </div>
            <div class="col text-center" v-if="t.type === 'lookup'">
              <h4 class="text-default text-uppercase">Lookup waiver</h4>
              <small>A searchable waiver form that allows guests to find and complete their waiver by entering identifying details. Ideal for public bookings.</small>
            </div>
            <div class="col text-center" v-if="t.type === 'generic'">
              <h4 class="text-default text-uppercase">Generic waiver</h4>
              <small>A standalone waiver not tied to a booking. Ideal for walk-ins: guests scan a QR code and sign on arrival.</small>
            </div>
          </div>
          <div class="row mt-auto justify-content-center">
            <base-button style="width: 90%" type="primary" @click="configureWaiver(t.id)">Configure</base-button>
          </div>
        </card>
      </div>
<!--      <div class="col-lg-3 col-md-6 col-sm-6 col-12">-->
<!--        <card class="card-white">-->
<!--          <div class="row justify-content-center">-->
<!--            <div class="col text-right">-->
<!--              <i class="tim-icons icon-check-2"></i>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="row justify-content-center">-->
<!--            <i class="tim-icons icon-link-72" style="font-size: xxx-large"></i>-->
<!--          </div>-->
<!--          <div class="row mt-3 justify-content-center">-->
<!--            <div class="col text-center">-->
<!--              <h4 class="text-default text-uppercase">Shareable waiver</h4>-->
<!--              <small>A unique link that takes customer to the waiver form for the events they purchased. Can be shared included in email.</small>-->
<!--            </div>-->

<!--          </div>-->
<!--          <div class="row mt-3 justify-content-center">-->
<!--            <base-button class="button-wide" type="primary" >Configure</base-button>-->
<!--          </div>-->
<!--        </card>-->
<!--      </div>-->
<!--      <div class="col-lg-3 col-md-6 col-sm-6 col-12">-->
<!--        <card class="card-white">-->
<!--          <div class="row justify-content-center">-->
<!--            <div class="col text-right">-->
<!--              <i class="tim-icons icon-check-2"></i>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="row justify-content-center">-->
<!--            <i class="tim-icons el-icon-search" style="font-size: xxx-large"></i>-->
<!--          </div>-->
<!--          <div class="row mt-3 justify-content-center">-->
<!--            <div class="col text-center">-->
<!--              <h4 class="text-default text-uppercase">Lookup waiver</h4>-->
<!--              <small>Enables customers to lookup their waiver by name. Ideal for public bookings.</small>-->
<!--            </div>-->

<!--          </div>-->
<!--          <div class="row mt-3 justify-content-center">-->
<!--            <base-button class="button-wide" type="primary" >Configure</base-button>-->
<!--          </div>-->
<!--        </card>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import {API_LOCATION, WAIVER_URL} from "@/api-config";
import axios from "axios";
import swal from "sweetalert2";
import {Auth} from "aws-amplify";
import {Badge} from "@/components";

export default {
  name: "WaiverConfigurationList",
  components: {
    Badge,
  },
  data() {
    return {
      companyId: localStorage.getItem('companyId'),
      companyGroupId: JSON.parse(localStorage.getItem('group')).id,
      loading:false,
      waiverTypes: []
    }
  },
  methods: {
    configureWaiver(id){
      this.$router.push({ path: '/waivers/settings', query: { id: id}})
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async getWaiverSettingTypes() {
      this.loading = true
      let url = API_LOCATION + 'companies/' + this.companyId + '/groups/' + this.companyGroupId + '/waiver-settings'
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}

      axios.get(url, config)
        .then(response => {
          this.waiverTypes = response.data.waiver_setting_types
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            swal({
              title: 'Error',
              html: 'You do not have access to this feature. Reach out to your admin regarding your site permissions.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else if(err.response.status == 500){
            swal({
              title: 'Error',
              html: 'The feature has not been enabled as part of your subscription plan.',
              type: 'error',
            }).then((response)=> {
              this.$router.push('/')
            })
          }
          else {
            swal('Error!', 'Something went wrong', 'error')
          }
        })

    },
  },
  mounted(){
    this.group = JSON.parse(localStorage.getItem('group'))
    this.getWaiverSettingTypes()
  }
}
</script>

<style scoped>

</style>
